import { Component, OnInit } from "@angular/core";
import { Reminder } from "../../model/reminder";
import { DialogCancelMedicalAppointmentComponent } from "../dialogs/medical-appointment-cancel/dialog-medical-appointment-cancel.component";
import { MedicalAppointmentCancel } from "../../model/medical-appointment-cancel";
import { MatDialog } from "@angular/material";
import { NotificationToastService } from "../../services/notification-toast.service";
import { ConfirmDialogService } from "../../services/confirm-dialog.service";
import { DomSanitizer } from "@angular/platform-browser";
import { ReservationService } from "../../services/reservation.service";
import { ActivatedRoute } from "@angular/router";
import { PdfService } from "src/app/services/pdf.service";

@Component({
  selector: "app-reminder-component",
  templateUrl: "./reminder.component.html",
  styleUrls: ["./reminder.component.css"],
})
export class ReminderComponent implements OnInit {
  medicalAppointmentId: number;
  reminder: Reminder;
  loading: boolean;

  constructor(
    public dialog: MatDialog,
    private notificationToastService: NotificationToastService,
    private confirmDialogService: ConfirmDialogService,
    private domSanitizer: DomSanitizer,
    private reservationService: ReservationService,
    private pdfService: PdfService,
    private route: ActivatedRoute
  ) {}

  sendMail() {
    const medicalAppointmentIds: number[] = [];
    medicalAppointmentIds.push(this.reminder.MedicalAppointmentId);

    this.reservationService
      .sendResevationMail(medicalAppointmentIds)
      .then(() => {
        this.notificationToastService.success(
          "Se ha enviado el mail",
          "Envio de mails"
        );
      })
      .catch((err) =>
        this.notificationToastService.error(
          "Error al enviar el mail " + JSON.stringify(err.error),
          "Envio de mails"
        )
      );
  }

  async printReminder() {
    try {
      const medicalAppointmentIds: number[] = [];
      medicalAppointmentIds.push(this.reminder.MedicalAppointmentId);
      const report = await this.reservationService.getReminderReport(
        medicalAppointmentIds
      );
      this.pdfService.base64ToPdfPrint(report.ReportBase64, "Recordatorio");
    } catch (err) {
      console.log(err);
    }
  }

  finish(): void {
    history.back();
  }

  async ngOnInit() {
    this.route.params.subscribe((params) => {
      this.medicalAppointmentId = params["MedicalAppointmentId"];
    });

    this.reminder = await this.reservationService.getReminder(
      this.medicalAppointmentId
    );
    this.reminder.CenterLogoSafeUrl = this.domSanitizer.bypassSecurityTrustUrl(
      "data:image/JPG;base64," + this.reminder.CenterLogo
    );
  }
}
